import { render, staticRenderFns } from "./DialogSendEmail.vue?vue&type=template&id=01f06539&scoped=true"
import script from "./DialogSendEmail.vue?vue&type=script&lang=js"
export * from "./DialogSendEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f06539",
  null
  
)

export default component.exports